var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-page',[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n    "+_vm._s(_vm.$t('pages.account.security.heading'))+"\n  ")]),_vm._v(" "),_c('t-grid',[_c('t-grid-row',[_c('t-grid-cell',[_c('FormCardChangePassword')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }